import { api } from 'data/api/api'

import { GetLabelOptionsResp } from '../types/label-options'

export const getLabelOptions = (shipmentId: number) =>
  api.get<GetLabelOptionsResp>(`shipments/${shipmentId}/label_options`)
